import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { PageSizes } from "../../../common/constants";
import { EntityIdObject, EntityObject } from "../../../common/types";
import {
  CertificateFuelType,
  CertificateFuelTypeFilterPageRequest,
  CertificateFuelTypeFilterPageResult,
  CreateUpdateCertificateFuelType,
} from "./types";

const FILTER_VEHICLE_FUEL_TYPES = ApiRequestAdapter.create("/vehicle-fuel-types", HttpMethod.GET);
const CREATE_VEHICLE_FUEL_TYPE = ApiRequestAdapter.create("/vehicle-fuel-types", HttpMethod.POST);
const UPDATE_VEHICLE_FUEL_TYPE = ApiRequestAdapter.create("/vehicle-fuel-types/{0}", HttpMethod.PUT);
const DELETE_VEHICLE_FUEL_TYPE = ApiRequestAdapter.create("/vehicle-fuel-types/{0}", HttpMethod.DELETE);

export const vehicleFuelTypeApi = {
  filterVehicleFuelTypes: (
    request: CertificateFuelTypeFilterPageRequest,
  ): AxiosPromise<CertificateFuelTypeFilterPageResult> => {
    return apiService.get(FILTER_VEHICLE_FUEL_TYPES.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createVehicleFuelType: (request: CreateUpdateCertificateFuelType): AxiosPromise<CertificateFuelType> => {
    return apiService.post(CREATE_VEHICLE_FUEL_TYPE.url, request);
  },
  updateVehicleFuelType: (
    request: EntityObject<CreateUpdateCertificateFuelType>,
  ): AxiosPromise<CertificateFuelType> => {
    return apiService.put(UPDATE_VEHICLE_FUEL_TYPE.getParametrizedUrl(request.id), request.object);
  },
  deleteVehicleFuelType: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_VEHICLE_FUEL_TYPE.getParametrizedUrl(request.id));
  },
};

export const FILTER_VEHICLE_FUEL_TYPES_QUERY_PARAMS: Required<CertificateFuelTypeFilterPageRequest> = {
  fuelTypes: [],
  fuelNameSources: [],
  keyword: "",
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
};
